export default __webpack_public_path__ + "static/media/BonusBoxOpen.50cc02d7.png";